const activityImages = {
  // web端
  web: {
    header: 'https://s1.hdslb.com/bfs/templar/york-static/pTNy99WHPZHwzY7w.png',
    video: 'https://s1.hdslb.com/bfs/templar/york-static/985yrhL1ccG3bbAV.png',
    career: 'https://s1.hdslb.com/bfs/templar/york-static/TohOJfC7OeXnhFyu.png',
    delivery: 'https://s1.hdslb.com/bfs/templar/york-static/fzrsfWLXLK2WiuWE.png',
    learnMore: 'https://s1.hdslb.com/bfs/templar/york-static/cJ7PiXfZfs2STGCr.png',
    btn_left: 'https://s1.hdslb.com/bfs/templar/york-static/tDODHG9wBQhAvcE7.png',
    btn_right: 'https://s1.hdslb.com/bfs/templar/york-static/jY1iMNuGjGsBKjjP.png',
    btn_delivery: 'https://s1.hdslb.com/bfs/templar/york-static/uPzmnGSJ6mlUDN2u.png',
    btnfollow: 'https://s1.hdslb.com/bfs/templar/york-static/1Rq8TcTuXzHgnMQz.png',
    btn_alreayfollow: 'https://s1.hdslb.com/bfs/templar/york-static/hidCyRzOv08S53mf.png',
    video1: 'https://s1.hdslb.com/bfs/templar/york-static/HC0GxmqEq78FH8FQ.png',
    video2: 'https://s1.hdslb.com/bfs/templar/york-static/6XDO30MuVKPDkynu.png',
  },
  // mobile端
  mobile: {
    header: 'https://s1.hdslb.com/bfs/templar/york-static/4SzHEMdBqUBtDUZV.png',
    video: 'https://s1.hdslb.com/bfs/templar/york-static/R81t3JtSeAJzje7m.png',
    career: 'https://s1.hdslb.com/bfs/templar/york-static/TVpkki6z8QXAC8jS.png',
    delivery: 'https://s1.hdslb.com/bfs/templar/york-static/jtAh5yAOJV3B882K.png',
    learnMore: 'https://s1.hdslb.com/bfs/templar/york-static/uyrPFtMajeiE6g3j.png',
    btn_left: 'https://s1.hdslb.com/bfs/templar/york-static/s8lr9g5qcRWQnutl.png',
    btn_right: 'https://s1.hdslb.com/bfs/templar/york-static/yeEurdnQCH6nLpwU.png',
    btn_delivery: 'https://s1.hdslb.com/bfs/templar/york-static/0EuUFj6zReUkyYei.png',
    btnfollow: 'https://s1.hdslb.com/bfs/templar/york-static/1Rq8TcTuXzHgnMQz.png',
    btn_alreayfollow: 'https://s1.hdslb.com/bfs/templar/york-static/odjdpo6DXm1CrIxp.png',
    video1: 'https://s1.hdslb.com/bfs/templar/york-static/lvTCKktITvPAgqEn.png',
    video2: 'https://s1.hdslb.com/bfs/templar/york-static/cljB6jFVmSXNc6l0.png',
  },
};
export default activityImages;
